import { useState } from "react";
import { API } from "@/App";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const NewsletterSignup = ({ variant = "light" }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    setIsSubmitting(true);

    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, name });
      setIsSubscribed(true);
      toast.success("Welcome to the inner circle!");
      setEmail("");
      setName("");
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error("This email is already subscribed");
      } else {
        toast.error("Something went wrong. Please try again.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubscribed) {
    return (
      <div className="text-center animate-fade-in" data-testid="newsletter-success">
        <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 ${
          variant === "dark" ? "bg-champagne-gold" : "bg-jade-deep"
        }`}>
          <Check className={`w-8 h-8 ${variant === "dark" ? "text-charcoal" : "text-white"}`} />
        </div>
        <p className={`font-body ${variant === "dark" ? "text-ivory" : "text-charcoal"}`}>
          You're in! Check your inbox for a welcome message.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto" data-testid="newsletter-form">
      <div className="space-y-4">
        <Input
          type="text"
          placeholder="Your name (optional)"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={`newsletter-input ${
            variant === "dark" 
              ? "bg-white/10 border-white/20 text-white placeholder:text-white/50" 
              : ""
          }`}
          data-testid="newsletter-name"
        />
        <div className="flex gap-3">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={`newsletter-input flex-1 ${
              variant === "dark" 
                ? "bg-white/10 border-white/20 text-white placeholder:text-white/50" 
                : ""
            }`}
            data-testid="newsletter-email"
          />
          <Button
            type="submit"
            disabled={isSubmitting}
            className={`rounded-full px-6 ${
              variant === "dark"
                ? "bg-champagne-gold text-charcoal hover:bg-champagne"
                : "btn-primary"
            }`}
            data-testid="newsletter-submit"
          >
            {isSubmitting ? (
              <span className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
            ) : (
              <ArrowRight className="w-5 h-5" />
            )}
          </Button>
        </div>
      </div>
      <p className={`font-body text-xs mt-4 ${variant === "dark" ? "text-ivory/60" : "text-taupe"}`}>
        Your privacy is sacred. Unsubscribe anytime.
      </p>
    </form>
  );
};

export default NewsletterSignup;
